var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead,"multiple":""}},[_c('van-icon',{attrs:{"name":"plus"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }